import type { ExtractPropTypes } from 'vue'

import { buildProps } from '@ll-plus/utils'

import type HeaderSearch from '../components/header-search.vue'

export const treeSelectHeaderSearchProps = buildProps({
  /**
   * @description input的value
   */
  searchValue: {
    type: String
  },
  /**
   * @description 节流时间
   */
  throttleTime: {
    type: Number
  },
  /**
   * @description 是否显示头部add按钮
   */
  isShowAddBtn: {
    type: Boolean,
    default: true
  },
  /**
   * @description input的change
   */
  onSearchInputChange: {
    type: Function
  }
} as const)

export const treeSelectHeaderSearchEmits = {
  click: (e: Event) => !!e // 点击新增按钮
}

// props
export type TreeSelectHeaderSearchProps = ExtractPropTypes<
  typeof treeSelectHeaderSearchProps
>

// emits
export type TreeSelectHeaderSearchEmits = ExtractPropTypes<
  typeof treeSelectHeaderSearchEmits
>

// instance
export type TreeSelectHeaderSearchInstance = InstanceType<typeof HeaderSearch>
